'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _coreDecorators = require('core-decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withToast = function withToast(_ref) {
  var _ref$propName = _ref.propName,
      propName = _ref$propName === undefined ? 'toast' : _ref$propName,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 3000 : _ref$duration;
  return function (WrappedComponent) {
    var _class;

    var WithToast = (0, _coreDecorators.autobind)(_class = function (_PureComponent) {
      (0, _inherits3.default)(WithToast, _PureComponent);

      function WithToast() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WithToast);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = WithToast.__proto__ || (0, _getPrototypeOf2.default)(WithToast)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
          visible: false,
          data: null,
          duration: duration
        }, _this.timer = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(WithToast, [{
        key: 'show',
        value: function show(_ref3) {
          var data = _ref3.data,
              openDuration = _ref3.duration;

          this.setState({
            visible: true,
            data: data,
            duration: openDuration !== undefined ? openDuration : this.state.duration
          }, this.startTimer);
        }
      }, {
        key: 'hide',
        value: function hide() {
          this.clearTimer();
          this.setState({ visible: false, data: null });
        }
      }, {
        key: 'startTimer',
        value: function startTimer() {
          var _this2 = this;

          var duration = this.state.duration;

          if (duration > 0) {
            this.timer = setTimeout(function () {
              return _this2.hide();
            }, duration);
          }
        }
      }, {
        key: 'clearTimer',
        value: function clearTimer() {
          clearTimeout(this.timer);
        }
      }, {
        key: 'handleMouseOver',
        value: function handleMouseOver() {
          this.clearTimer();
        }
      }, {
        key: 'handleMouseOut',
        value: function handleMouseOut() {
          this.startTimer();
        }
      }, {
        key: 'render',
        value: function render() {
          var _state = this.state,
              visible = _state.visible,
              data = _state.data;

          return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, this.props, (0, _defineProperty3.default)({}, propName, {
            show: this.show,
            hide: this.hide,
            isVisible: visible,
            data: data,
            eventHandlers: {
              onMouseOver: this.handleMouseOver,
              onMouseOut: this.handleMouseOut
            }
          })));
        }
      }]);
      return WithToast;
    }(_react.PureComponent)) || _class;

    return WithToast;
  };
};

exports.default = withToast;